import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import UserService from "../../services/UserService";
import firebase from "../../services/FirebaseService";
import DonateService from "../../services/DonateService";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import "../../assets/style/admin/requests.css";

const Donations = () => {

	const donateService = new DonateService();
	
	const [ requests, setRequests ] = useState([]);
	const [ pending, setPending ] = useState(true);
	const [ success, setSuccess ] = useState(false);

	(async () => {
		
		try {
			const requestList = await donateService.getDonations();

			setRequests(requestList);
			setPending(false);
		}
		catch(error) {
			console.error(error);
		}
		
	})();

	const deleteRequest = async (id) => {

		setPending(true);
		console.log(id);
		
		try {
			await donateService.deleteDonation(id);
			
			setSuccess(true);
		}
		catch(error) {
			console.error(error);
			setSuccess(false);
		}
	};

	return (
		<section id="admin-requests">
			{ success && <Redirect to="/admin"/> }
			{ (!pending && requests.length === 0) && <p>There is no current donation requests. Check again later!</p> }
			{
				requests.map(request => <article>
					<div>
						<h1>Date</h1>
						<h3>{request.date.toLocaleString()}</h3>
					</div>
					<div>
						<h1>Email</h1>
						<h3>{request.email}</h3>
					</div>
					{request.whatsapp && 
						<div>
							<h1>WhatsApp</h1>
							<h3>{request.whatsapp}</h3>
						</div>
					}
					{request.instagram && 
						<div>
							<h1>Instagram</h1>
							<h3>{request.instagram}</h3>
						</div>
					}
					<button
						disabled={pending}
						type="button"
						onClick={() => deleteRequest(request.id)}
					>Delete Request</button>
				</article>)
			}
		</section>
	);
};

const DonationsPage = () => {
	
	const userService = new UserService();

	const [ privileged, setPriviledged ] = useState(0);

	firebase.auth().onAuthStateChanged(async user => {
		
		if(user) {
			const isAdmin = await userService.isUserAdmin(user.uid);

			isAdmin ? setPriviledged(1) : setPriviledged(2);
		}
		else {
			setPriviledged(2);
		}

	});

	return (
		<>
			{ privileged === 2 && <Redirect to="/" /> }
			{ privileged === 1 && 
				<>
					<Navbar />
					<Donations />
					<Footer />
				</>
			}
		</>
	)

};

export default DonationsPage;